/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePalReauthEmrDocumentSelection200ResponseData
 */
export interface UpdatePalReauthEmrDocumentSelection200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof UpdatePalReauthEmrDocumentSelection200ResponseData
     */
    external_emr_document_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePalReauthEmrDocumentSelection200ResponseData
     */
    is_selected: boolean;
}

/**
 * Check if a given object implements the UpdatePalReauthEmrDocumentSelection200ResponseData interface.
 */
export function instanceOfUpdatePalReauthEmrDocumentSelection200ResponseData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "external_emr_document_id" in value;
    isInstance = isInstance && "is_selected" in value;

    return isInstance;
}

export function UpdatePalReauthEmrDocumentSelection200ResponseDataFromJSON(json: any): UpdatePalReauthEmrDocumentSelection200ResponseData {
    return UpdatePalReauthEmrDocumentSelection200ResponseDataFromJSONTyped(json, false);
}

export function UpdatePalReauthEmrDocumentSelection200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthEmrDocumentSelection200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'external_emr_document_id': json['external_emr_document_id'],
        'is_selected': json['is_selected'],
    };
}

export function UpdatePalReauthEmrDocumentSelection200ResponseDataToJSON(value?: UpdatePalReauthEmrDocumentSelection200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'external_emr_document_id': value.external_emr_document_id,
        'is_selected': value.is_selected,
    };
}

